import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Form, FormInstance, Input, notification } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAuthUrl,downloadMbConfig,mdmUserLogin } from "../axios/api.feishu";
import { v4 as uuidv4 } from "uuid";
import Store from "../redux/store";
import "./pages.scss";

const getQueryParams = (): Record<string, string> => {
  const params: Record<string, string> = {};
  const queryString = window.location.search.substring(1);
  const pairs = queryString.split('&');
  
  for (const pair of pairs) {
    const [key, value] = pair.split('=');
    if (key && value) {
      params[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  }
  
  return params;
};

export function CustomLogin() {
    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);
    const [error, setError] = useState<string>("");
    const [companyId, setCompanyId] = useState<string>("");
    const [adeId, setAdeId] = useState<string>("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [isAdminAndFeishu, setIsAdminAndFeishu] = useState(false);
    const [isFeishu, setIsFeishu] = useState(false);
    const [isMdmUser, setIsMdmUser] = useState(false);
    const [serialNo, setSerialNo] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [mdmForm] = Form.useForm();

    useEffect(() => {
      const params = getQueryParams();
      const code = params.code;
      const error = params.error;
      const companyId = params.companyId;
      const adeId = params.adeId;
      const customWebTypes = params.customWebTypes;
      const serialNo = params.serialNo;
      // if(customWebTypes?.includes('admin') && customWebTypes?.includes('feishu'))
      //   setIsAdminAndFeishu(true);
      if(customWebTypes?.includes('feishu'))
        setIsFeishu(true);
      else if(customWebTypes?.includes('mdmUser'))
        setIsMdmUser(true);
      else if(customWebTypes?.includes('admin'))
        setIsAdmin(true);

      if(!error && companyId)
      {
        localStorage.setItem("sourceUrl", window.location.href);
      }
      setCompanyId(companyId);
      setAdeId(adeId);
      setSerialNo(serialNo);
      if(error)
        setError(error);
      if (code && !isProcessing) {
        setIsProcessing(true);
      }
    }, []);

    const handleFeishuLogin = async (): Promise<void> => {
      if (loading) return; // 防重复点击
      setLoading(true);
      try{
        const authUrl = await getAuthUrl({companyId: companyId, adeId: adeId, serialNo: serialNo});
        if (authUrl) {
          window.location.href = authUrl.url;
        } else {
          notification.error({ message: "获取飞书登录地址失败" });
        }
      }catch{
        notification.error({ message: "跳转失败请重试" });
        setLoading(false);
      }
    }  

    const returnUrl = async (): Promise<void> => {
      var sourceUrl = localStorage.getItem('sourceUrl');
      if(sourceUrl)
      {
        window.location.href=sourceUrl;
      }
    };

    const downMobile = async (): Promise<void> => {
        try {
          const configUrl = `${process.env.REACT_APP_API_URL}/apns/mobileconfig?companyId=${companyId}&adeId=${adeId}`;
    
          // 方式1: 使用window.location跳转
          window.location.href = configUrl;
        } catch (error) {
          console.error('下载失败:', error);
          alert('下载失败，请稍后重试或联系管理员。');
        }
    };

    // const downMobile = async (): Promise<void> => {
    //     try {
    //       // 显示加载状态（可选）
    //       const response = await fetch(`${process.env.REACT_APP_API_URL}/apns/mobileconfig?companyId=${companyId}&adeId=${adeId}`, {
    //         method: 'GET',
    //         headers: {
    //           'Content-Type': 'application/x-apple-aspen-config',
    //         },
    //       });

    //       if (!response.ok) {
    //         throw new Error(`HTTP error! status: ${response.status}`);
    //       }

    //       // 获取返回的 blob 数据
    //       const blob = await response.blob();

    //       // 创建下载链接
    //       const url = window.URL.createObjectURL(blob);
    //       const a = document.createElement('a');
    //       a.href = url;

    //       let fileName = `${uuidv4()}.mobileconfig`;
    //       a.download = fileName; // 文件名
    //       document.body.appendChild(a);
    //       a.click();

    //       // 清理
    //       window.URL.revokeObjectURL(url);
    //       document.body.removeChild(a);
    //     } catch (error) {
    //       console.error('下载失败:', error);
    //       alert('下载失败，请稍后重试或联系管理员。');
    //     }
    // };

    const handleMdmLogin = async (): Promise<void> => {
      setLoading(true);
      try {
        // 1. 调用后端接口验证用户名密码
        // const response = await api.login(values.username, values.password);
        var res = await mdmForm?.validateFields();
        console.log(res);
        res.companyId = companyId;
        res.adeId = adeId;
        res.serialNumber = serialNo;
        await mdmUserLogin(res);
        await downMobile();
      } catch (err) {
        //notification.error({ message: "验证失败，请检查用户名密码" });
      } finally {
        setLoading(false);
      }
    };
    
    return (
      <div className="login-container" style={{backgroundImage: "url(images/bg.png)"}}>
      <div className="logo-container">  
        <img width={100} src="/images/icon_n.png"></img>
      </div>
      <div className="logo-container">  
        {/* 这里应该放置TAPD的Logo */}  
        <h1>{t("未瓴移动设备管理平台")}</h1>
      </div>
      <div className="logo-container">  
        {error && <h2>{error}</h2> } 
      </div>
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        { error &&  <Button 
              type="primary" 
              size="large" 
              onClick={returnUrl}
              style={{ width: '100%', height: '40px' }}
            >
              返回
            </Button>
        }
        { (!error && isFeishu) &&  <Button 
              disabled={loading}
              type="primary" 
              size="large" 
              onClick={handleFeishuLogin}
              style={{ width: '100%', height: '40px' }}
            >
              {loading ?'跳转中...' : '使用飞书登录' } 
            </Button>
        }
         {/* MDM 用户登录 - 新增部分 */}
        { (!error && isMdmUser) && (
          <div style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}>
            <Form
              form={mdmForm}
              layout="vertical"
              onFinish={handleMdmLogin}
              autoComplete="off"
            >
              <Form.Item
                name="userName"
                rules={[{ required: true, message: '请输入用户名' }]}
                style={{ marginBottom: 12 }}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="邮箱" 
                  size="large" 
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码' }]}
                style={{ marginBottom: 16 }}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="密码"
                  size="large"
                />
              </Form.Item>

              <Button 
                htmlType="submit"
                disabled={loading}
                type="primary" 
                size="large" 
                style={{ width: '100%', height: '40px' }}
              >
                {loading ? '验证中...' : '登录验证'}
              </Button>
            </Form>
          </div>
        )}
      </div>
    </div> 
    )
}